module.exports = __webpack_public_path__ + "media/images/area/area_kantoM400-e7a7b3a79c802205212745d7f79d3d19.jpg";